var _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthPageBottomLeftIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 359,
    viewBox: "0 0 622 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 229,
    cy: 434,
    rx: 393,
    ry: 434,
    fill: "#061317"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.981,
    cy: 164.851,
    rx: 52.9809,
    ry: 55.8513,
    fill: "#103944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthPageBottomLeftIllustration);
export default __webpack_public_path__ + "static/media/auth-page-bottom-left-illustration.549638c841c5b4248c6a89183fd9d9ea.svg";
export { ForwardRef as ReactComponent };